"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { IconHelpCircle } from "@tabler/icons-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { DiscountCoupon } from "./DiscountCoupon";
import { DiscountSitewidePromo } from "./DiscountSitewidePromo";
interface Props {
  item: CartItemOutputDto;
}
export function CartItemDiscount(t0) {
  const $ = _c(3);
  const {
    item
  } = t0;
  if (!item.discountAmount) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PopoverTrigger asChild={true}><button type="button" className="flex items-center justify-end gap-1"><span className="text-xs font-medium leading-none text-green-700">Discounted</span><IconHelpCircle className="shrink-0 text-green-700" size={16} /></button></PopoverTrigger>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== item) {
    t2 = <Popover>{t1}<PopoverContent align="end" className="flex w-[295px] flex-col gap-4 border-border/50 p-4"><DiscountSitewidePromo item={item} /><DiscountCoupon item={item} /></PopoverContent></Popover>;
    $[1] = item;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}